export default __webpack_public_path__ + "a8d254f22643c0d888318514fa87f535.png";